/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { IconButton, } from "@mui/material";

const FocusAreaPosition = (props) => {
    
    const {
        positions,
        selectedPosition,
        selectPositionType,
    } = props || {};
    
    return (
        <div className='component-box' style={{
            // border: '1px solid red',
            display: "flex", gap: "12px", alignContent: "center" }}
        >
            <div
                className='component-box'
            >
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "4px",
                    flexShrink: 0,
                    flexWrap: "wrap",
                    // border: '1px solid red',
                    width: "142px",
                    height: "144px"
                }}
                >
                    {positions.map((position, index) => {
                        const Icon = position.icon;
                        const selectedClass = (selectedPosition === position.value)
                            ? "selected-position" : "unselected-position";
                        return (
                            <div key={index}>
                                <IconButton
                                    className={selectedClass}
                                    title={position.name}
                                    aria-label={position.name}
                                    size='large'
                                    onClick={(event) => {
                                        selectPositionType(event, position.value);
                                    }}
                                >
                                    <Icon/>
                                </IconButton>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default FocusAreaPosition;
